export default __webpack_public_path__ + "static/media/bgObs.4b14ac58.png";